import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms'
import { SignupService } from 'src/app/services/signup.service';
import { ToastrService } from 'ngx-toastr';
import { FacebookService, InitParams, LoginOptions, LoginResponse } from 'ngx-facebook';
import { WatcherService } from 'src/app/services/watcher.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MetaPixelService } from 'src/app/services/metapixel.service';
import firebase from 'firebase/compat/app';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import * as AuthActions from '../../store/shared/auth/auth.actions'
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { InvisibleReCaptchaComponent } from 'ngx-captcha';
import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
declare var $;

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit, AfterViewInit {
  facebookLoginErrorMessage;
  counrtyList;
  findList;
  socialLoginToken;
  firstName;
  lastName;
  selectedCountry;
  email;
  password;
  repassword;
  selectedFindOption;
  passingSignupData = false;
  passwordError;
  emailError;
  surnameError;
  nameError;
  googleRecapthaSiteKey = "6LfzUlUaAAAAAKKv0UBaepUWBOJKiZ62xqtvqREh";
  helloFrom: string = '';
  form = new UntypedFormGroup({
    firstName: new UntypedFormControl('', Validators.required),
    lastName: new UntypedFormControl('', Validators.required),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    password: new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(6),

    ]),
    repassword: new UntypedFormControl('', [
      Validators.required,
      Validators.minLength(6)
    ]),
    country: new UntypedFormControl('', Validators.required),
    recaptcha: new UntypedFormControl('', Validators.required),
    receiveCheckbox: new UntypedFormControl(true)
  }, { validators: this.controlPasswordValidator('password', 'repassword') })

  socialUpdateForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
  })

  happyMembers = [
    {
      name: 'John B.',
      thumbnail: 'man',
      country: 'U.S.A.',
      country_code: 'extra',
      pp_url: 'user-us-01',
      comment: 'Loved it! Clear communication, fast response, and received a picture of my items before being shipped which made me very happy!'
    },
    {
      name: 'Kristen T.',
      thumbnail: 'woman',
      country: 'United Kingdom',
      country_code: 'uk',
      pp_url: 'Kirsten-T-UK',
      comment: 'Very happy about my first experience of this kind of service. The only note: it would be good to have an estimate in advance of how much the shipment would cost.'
    },
    {
      name: 'Emily M.',
      thumbnail: 'woman',
      country: 'Canada',
      country_code: 'canada',
      pp_url: 'Emily-M-Canada',
      comment: 'Another great service from Shippn. US host Michael is an amazing person, great communication, support and help. This what you are looking for from companies like Shippn - TRUST and SUPPORT!'
    }
  ]

  writingPassword(event) {
    this.password = event.target.value;
    // if(this.password !== this.repassword){
    //   this.form.get('password').setErrors({'passwordsDoNotMatch': true});
    //   this.form.get('repassword').setErrors({'passwordsDoNotMatch': true});
    // }
  }
  writingRePassword(event) {
    this.repassword = event.target.value;
    // if(this.password !== this.repassword){
    //   this.form.get('password').setErrors({'passwordsDoNotMatch': true});
    //   this.form.get('repassword').setErrors({'passwordsDoNotMatch': true});
    // }
  }

  isWebview = () => {
    if (typeof window === undefined) { return false };
    let navigator: any = window.navigator;
    const standalone = navigator.standalone;
    const userAgent = navigator.userAgent.toLowerCase();
    const safari = /safari/.test(userAgent);
    const ios = /iphone|ipod|ipad/.test(userAgent);
    return ios ? !standalone && !safari : userAgent.includes('wv');
  }
  isAndrodiWebview = () => {
    let isWebView = false;
    let userAgent = navigator.userAgent;
    if (/Android/.test(userAgent)) {
      var androidVersion = parseFloat(userAgent.slice(userAgent.indexOf("Android") + 8));
      if (androidVersion >= 10) {
        isWebView = /(wv)/.test(userAgent);
      } else {
        isWebView = userAgent.includes("Version/");
      }
    }
    if (isWebView) {
      return true
    } else {
      return false;
    }
  }



  constructor(
    public signUpService: SignupService,
    private toastr: ToastrService,
    private fb: FacebookService,
    private watcherService: WatcherService,
    private activatedRoute: ActivatedRoute,
    private metaPixelService: MetaPixelService,
    private router: Router,
    private store: Store<AppState>,
    private gtmService: GoogleTagManagerService
  ) {

    const initParams: InitParams = {
      //appId: '162560842317790',
      //appId: '558848698455833',
      appId: '558848698455833',
      status: true,
      cookie: true,
      xfbml: true,
      version: 'v17.0'
    };

    fb.init(initParams);
    this.signUpService.getAllCountries().subscribe(data => {
      this.counrtyList = data["data"]
    });
    this.signUpService.getUserIPData().subscribe(data => {
      const countryCode = data['country'] === 'GB' ? 'UK' : data['country'];
      this.form.patchValue({ country: countryCode });

    })
    this.activatedRoute.params.subscribe(params => {

      this.helloFrom = params['landingPage'];
    })
  }
  lang;
  platformisWebView = false;
  isThereReferPromocode: boolean = false;
  referPromoCode: string = '';
  ngOnInit(): void {
    if (this.isAndrodiWebview() || this.isWebview()) {
      this.platformisWebView = true;
    }
    this.watcherService.getLang().subscribe(
      lang => {
        this.lang = lang;
        this.lang = lang;
      }
    )
    window.addEventListener('blur', () => {
      this.signUpService.updateWebsiteTitle("Come back! | Start Shopping From Abroad - Shippn");
    })
    window.addEventListener('focus', () => {
      this.signUpService.updateWebsiteTitle("Sign Up | Start Shopping From Abroad - Shippn");
    })
    if (this.isWebview() || this.isAndrodiWebview()) {
    }
    this.activatedRoute.queryParams.subscribe(queryParams => {

      if (queryParams?.promo_code) {
        this.isThereReferPromocode = true;
        this.referPromoCode = queryParams?.promo_code;
        localStorage.setItem('referPromoCode', this.referPromoCode);
      } else {
        this.isThereReferPromocode = false;
      }
    })
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }
  @ViewChild('captchaElem') captchaElem: InvisibleReCaptchaComponent;

  resetCaptcha() {
    this.captchaElem.resetCaptcha();
  }
  onCaptchaExpired() {
    this.resetCaptcha();
  }
  signUp() {
    if (this.checkInputValidations() == false) {
      let payload = {
        country_code: this.form.value.country,
        email: this.form.value.email.toLowerCase(),
        google: { action: 'SIGN_UP', token: this.form.value.recaptcha },
        mail_permission: this.form.value.receiveCheckbox,
        name: this.form.value.firstName,
        password: this.form.value.password,
        surname: this.form.value.lastName
      }
      this.signUpService.signUpwithEmail(
        payload
      ).subscribe({
        next: data => {
          if (data["result"]["status"] == 200) {

            const gtmTag = {
              event: 'gtmSignUp',
              data: { email: this.form.value.email.toLowerCase() }
            }
            this.gtmService.pushTag(gtmTag);
            localStorage.setItem('token', data["data"]["token"]);
            localStorage.setItem('is_email_verified', data["data"]["user"]["is_email_verified"]);
            localStorage.setItem('userId', data["data"]["user"]["id"]);
            localStorage.setItem('is_phone_verified', data["data"]["user"]["is_phone_verified"]);
            localStorage.setItem('CACHED_USER', JSON.stringify(data["data"]['user']));
            //this.metaPixelService.onSignUpEvent(data["data"].user.email);
            let user: object = data["data"]['user'];
            this.store.dispatch(AuthActions.LoginSuccess({ token: data['data']['token'], user }))
            this.router.navigate(['/','verification', 'signup-success'])
          }
          else {
            this.toastr.error(data["result"]["message"], 'Error');
            this.passingSignupData = false;
            this.resetCaptcha();
          }
        },
        error: err => {
          const errorMessage = err?.error?.result?.message || err?.message || JSON.stringify(err);
          this.toastr.error(errorMessage, 'Error');
          this.resetCaptcha();
          this.passingSignupData = false;
        }
      })
    }
  }

  loginWithFacebook(): void {

    document.getElementById("facebookLoginStatusModalBtn").click();
    let loginOptions: LoginOptions = {
      scope: 'email'
    }

    this.fb.login(loginOptions)
      .then((response: LoginResponse) => {
        var userData = {
          "access_token": response.authResponse.accessToken,
          "facebook_user_id": response.authResponse.userID,
          "type": 1
        }

        this.signUpService.signUpwithFacebook(userData).subscribe(data => {
          if (data["result"]["status"] == 200) {

            localStorage.setItem('token', data["data"]["token"]);
            localStorage.setItem('is_email_verified', data["data"]["user"]["is_email_verified"]);
            localStorage.setItem('userId', data["data"]["user"]["id"]);
            localStorage.setItem('is_phone_verified', data["data"]["user"]["is_phone_verified"]);
            localStorage.setItem('CACHED_USER', JSON.stringify(data["data"]['user']));
            //this.metaPixelService.onSignUpEvent(data["data"].user.email);
            document.getElementById('facebookLoginCloseModalBtn').click();
            let user: object = data["data"]['user'];
            this.store.dispatch(AuthActions.LoginSuccess({ token: data['data']['token'], user }))
            this.router.navigate(['/','verification', 'signup-success'])
          }
          else {
            this.toastr.error(data["result"]["message"], 'Error');
            //this.passingSignupData = false;

            if (data["result"]["status"] == 855) {
              //this.updateSocialLoginProfile(data["data"]["token"])
              document.getElementById('facebookLoginCloseModalBtn').click();
              document.getElementById("socialUpdateModalTriggerBtn").click();
              this.socialLoginToken = data["data"]["token"]
            }
          }
        })

      })
      .catch((error: any) => { });
  }

  loginWithGoogle(): void {
    const provider = new GoogleAuthProvider();
    const auth = getAuth();

    signInWithPopup(auth, provider).then((val) => {
      const credential = GoogleAuthProvider.credentialFromResult(val);
      const accessTokenFromFire = credential?.accessToken;

      const userData = {
        access_token: accessTokenFromFire,
        type: 1
      };
      this.signUpService.signUpwithGoogle(userData).subscribe(data => {
        if (data["result"]["status"] == 200) {
          const gtmTag = {
            event: 'gtmSignUp',
            data: { email: data["data"].user.email }
          }
          this.gtmService.pushTag(gtmTag);
          localStorage.setItem('token', data["data"]["token"]);
          localStorage.setItem('is_email_verified', data["data"]["user"]["is_email_verified"]);
          localStorage.setItem('userId', data["data"]["user"]["id"]);
          localStorage.setItem('is_phone_verified', data["data"]["user"]["is_phone_verified"]);
          localStorage.setItem('CACHED_USER', JSON.stringify(data["data"]['user']));
          //this.metaPixelService.onSignUpEvent(data["data"].user.email);
          let user: object = data["data"]['user'];
          this.store.dispatch(AuthActions.LoginSuccess({ token: data['data']['token'], user }))
          this.router.navigate(['/','verification', 'signup-success'])
        }
        else {
          this.toastr.error(data["result"]["message"], 'Error');
          //this.passingSignupData = false;
        }
      })
    })
  }

  keyPressAlphabethic(event) {

    var inp = String.fromCharCode(event.keyCode);

    if (/[a-zA-Z]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  checkInputValidations() {
    var hasError = false

    if (this.form.controls.firstName.status == "INVALID") {
      this.form.controls.firstName.markAsTouched()
      hasError = true;
    }

    if (this.form.controls.lastName.status == "INVALID") {
      this.form.controls.lastName.markAsTouched()
      hasError = true;
    }

    if (this.form.controls.email.status == "INVALID") {
      this.form.controls.email.markAsTouched()
      hasError = true;
    }

    if (this.form.controls.password.status == "INVALID") {
      this.form.controls.password.markAsTouched()
      hasError = true;
    }
    if (this.form.controls.repassword.status == "INVALID") {
      this.form.controls.repassword.markAsTouched()
      hasError = true;
    }

    if (this.form.controls.country.status == "INVALID") {
      this.form.controls.country.markAsTouched()
      hasError = true;
    }

    if (this.form.controls.recaptcha.status == "INVALID") {
      this.form.controls.recaptcha.markAsTouched()
      hasError = true;
    }
    if (this.form.status == "INVALID") {
      this.form.markAsTouched()
      hasError = true;
    }

    return hasError;


  }

  socialUpdateValidation() {
    var hasError = false

    if (this.socialUpdateForm.controls.email.status == "INVALID") {
      this.socialUpdateForm.controls.email.markAsTouched()
      hasError = true;
    }

    return hasError;
  }

  updateSocialLoginProfile() {
    if (this.socialUpdateValidation() == false) {
      var facebokData = {
        "email": this.socialUpdateForm.value.email.toLowerCase()
      }
      this.signUpService.updateUserDataForFacebookSocialLogin(this.socialLoginToken, facebokData).subscribe(data => {
        if (data["result"]["status"] == 200) {
          const gtmTag = {
            event: 'gtmSignUp',
            data: { email: this.socialUpdateForm.value.email.toLowerCase() }
          }
          this.gtmService.pushTag(gtmTag);
          this.toastr.success(data["result"]["message"], 'Success');
          $('#socialUpdateModal').modal('hide')
          localStorage.setItem('token', this.socialLoginToken);
          localStorage.setItem('is_email_verified', data["data"]["is_email_verified"]);
          localStorage.setItem('userId', data["data"]["id"]);
          localStorage.setItem('is_phone_verified', data["data"]["is_phone_verified"]);
          localStorage.setItem('CACHED_USER', JSON.stringify(data["data"]));
          let user: object = data["data"]['user'];
          this.store.dispatch(AuthActions.LoginSuccess({ token: this.socialLoginToken, user }))
          this.router.navigate(['/','verification', 'signup-success'])
        }
        else {
          this.toastr.error(data["result"]["message"], 'Error');
        }

      })
    }
  }

  private controlPasswordValidator(controlPassword: string, controlRepassword: string): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const fGroup = control as UntypedFormGroup;
      const password = fGroup.get(controlPassword)?.value;
      const confirmPassword = fGroup.get(controlRepassword)?.value;
      if (password === confirmPassword) {
        return null;
      } else {
        return { passwordsDoNotMatch: true };
      }

    }
  }


}
